package Structs


import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import myName

@myName("MsgTracker")
@Serializable
class MsgTracker(
    val unique_id:Int?=null,
    var contact: String?=null,
    val method:String?=null,
    val msg_id: Int? = null,
    val company_id: Int? = null,

    val type: Int? = null,
    var title: String? = null,
    val msg: String? = null,
    var send: Int? = null,
    val err: String? = null,
    val tries: Int? = null,
    val validate: Int? = null,
    val date_send: String? = null,
    val date_updated: String? = null,
    val date_created: String? = null,
    val name: String? = null,
    val date_action: String? = null,

    ) {
    fun toJson(): JsonObject? {
        val map: MutableMap<String, JsonPrimitive> = mutableMapOf()
        if (msg_id != null)
            map["msg_id"] = JsonPrimitive(msg_id.toString())
        if (company_id != null)
            map["company_id"] = JsonPrimitive(company_id.toString())
        if (type != null)
            map["type"] = JsonPrimitive(type.toString())
        if (title != null)
            map["title"] = JsonPrimitive(title)
        if (msg != null)
            map["msg"] = JsonPrimitive(msg)
        if (send != null)
            map["send"] = JsonPrimitive(send.toString())
        if (err != null)
            map["err"] = JsonPrimitive(err)
        if (tries != null)
            map["tries"] = JsonPrimitive(tries.toString())
        if (validate != null)
            map["validate"] = JsonPrimitive(validate.toString())
        if (date_send != null)
            map["date_send"] = JsonPrimitive(date_send)
        if (date_updated != null)
            map["date_updated"] = JsonPrimitive(date_updated)
        if (unique_id != null)
            map["unique_id"] = JsonPrimitive(unique_id.toString())
        if (contact != null)
            map["contact"] = JsonPrimitive(contact)
        if (method != null)
            map["method"] = JsonPrimitive(method)
        if (name != null)
            map["name"] = JsonPrimitive(name)
        if (date_action != null)
            map["date_action"] = JsonPrimitive(date_action)

        if(map.isEmpty()) return null
        return JsonObject(map)
    }
}